import uuid from 'uuid/v4';

/**
 * ID Generator
 * ============
 *
 * Generates IDs that are unique, unless you override it, such as for unit testing.
 */
let idGen = () => uuid();
export default (...args) => idGen(...args);

/**
 * Sets the ID generator override
 *
 * @param  {function} overrideIdGen - ID generator function
 * @return {functino} previous ID generator function
 */
export function setIdGen(overrideIdGen) {
    const previousIdGen = idGen;
    idGen = overrideIdGen;
    return previousIdGen;
}
